import React from 'react';
import { isEmptyObject } from '../../core/util/object';
import { roundRating } from '~/core/util/numeric';

type OwnProps = {
  starRating?: number;
  showRatingMessage?: boolean;
  showEmptyRating?: boolean;
  size: number;
  containerClassName?: string;
  displayValue?: boolean;
  scores?: any;
  color?: string;
  showCompact?: boolean;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof StarRating.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'StarRating' implicitly has type 'any' because it ... Remove this comment to see the full error message
const StarRating = (props: Props) => {
  const starValues: any = [];
  for (let i = 0; i < 5; i++) {
    starValues.push(props.starRating - i > 1 ? 1 : props.starRating - i);
  }

  const starImage = (starValue: any) => {
    if (starValue >= 0.75) {
      return `star_filled${props.color}.svg`;
    }
    if (starValue >= 0.25) {
      return `star_half_filled${props.color}.svg`;
    }

    return 'star_empty.svg';
  };

  const stars = () => {
    if (props.showCompact) {
      return (
        <img
          height={props.size}
          role="presentation"
          src={`/images/icons/star_filled${props.color}.svg`}
          width={props.size}
        />
      );
    }
    return starValues.map((starValue: any, i: any) => (
      <img
        height={props.size}
        key={i}
        role="presentation"
        src={`/images/icons/${starImage(starValue)}`}
        width={props.size}
      />
    ));
  };

  const starValue = (value: any) => {
    if (value === 0 || typeof value === 'undefined' || value === null) {
      if (props.showRatingMessage) {
        return 'No Ratings';
      }
    }

    return roundRating(value);
  };

  const reviewCount = (scores: any) => {
    if (
      !isEmptyObject(scores) &&
      !isEmptyObject(scores.aggregated) &&
      !isEmptyObject(scores.aggregated[0])
    ) {
      return scores.aggregated[0].review_count;
    }

    // choose a number between 1 and 10, inclusive
    return Math.ceil(10 * Math.random());
  };

  return (
    <span className={props.containerClassName}>
      {(props.starRating !== 0 || props.showEmptyRating) && stars()}
      {props.displayValue && <span itemProp="ratingValue">{starValue(props.starRating)}</span>}
      {props.displayValue && (
        <div hidden itemProp="reviewCount">
          {reviewCount(props.scores)}
        </div>
      )}
    </span>
  );
};

StarRating.defaultProps = {
  displayValue: false,
  showRatingMessage: true,
  color: '',
};

export default StarRating;
